module.exports = __webpack_public_path__ + "static/img/Marco-Tilio.3e807f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Marco-Tilio.jpg
// module id = qGWW
// module chunks = 0